import { usePersistStore } from '@/store/persist.store'

/**
 * Hook to get the visible user name
 * Returns the user's name or a default value if not available
 */
const useVisibleUserName = (): string => {
  return usePersistStore(state => {
    const visibleUserData = state.user?.userName || state.user?.userId

    if (visibleUserData && visibleUserData !== 'null null') {
      return visibleUserData
    }

    return 'guest'
  })
}

export default useVisibleUserName
